
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const GREEN = "#087443";
const DARK = "#064d35";

const services = [
    { icon: "🌱", title: "Apply for Subsidy", desc: "Explore financial assistance" },
    { icon: "🔎", title: "Track Application", desc: "Check application progress" },
    { icon: "💧", title: "Drip Irrigation", desc: "Water-saving schemes" },
    { icon: "🌿", title: "Planting Materials", desc: "Find plants and nurseries" },
    { icon: "👨‍🌾", title: "Farmer Registration", desc: "Farmer registration services" },
    { icon: "📍", title: "Find an Officer", desc: "Locate district officers" },
];

const schemes = [
    {
        title: "MIDH / NHM",
        desc: "National Horticulture Mission",
        image:
            "https://images.unsplash.com/photo-1499529112087-3cb3b73cec95?auto=format&fit=crop&w=600&q=80",
    },
    {
        title: "Protected Cultivation",
        desc: "Greenhouses and shade nets",
        image:
            "https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?auto=format&fit=crop&w=600&q=80",
    },
    {
        title: "Micro Irrigation",
        desc: "Efficient water management",
        image:
            "https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?auto=format&fit=crop&w=600&q=80",
    },
    {
        title: "Post Harvest Management",
        desc: "Storage and infrastructure",
        image:
            "https://images.unsplash.com/photo-1604719312566-8912e9c8a213?auto=format&fit=crop&w=600&q=80",
    },
    {
        title: "Organic Farming",
        desc: "Sustainable farming practices",
        image:
            "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=600&q=80",
    },
    {
        title: "Nursery Development",
        desc: "Quality planting materials",
        image:
            "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=600&q=80",
    },
];

const crops = [
    {
        name: "Fruits",
        icon: "🥭",
        image:
            "https://images.unsplash.com/photo-1610832958506-aa56368176cf?auto=format&fit=crop&w=700&q=80",
    },
    {
        name: "Vegetables",
        icon: "🥬",
        image:
            "https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=700&q=80",
    },
    {
        name: "Flowers",
        icon: "🌺",
        image:
            "https://images.unsplash.com/photo-1490750967868-88aa4486c946?auto=format&fit=crop&w=700&q=80",
    },
    {
        name: "Plantation Crops",
        icon: "🌴",
        image:
            "https://images.unsplash.com/photo-1511497584788-876760111969?auto=format&fit=crop&w=700&q=80",
    },
];

const districts = [
    "Ariyalur",
    "Chengalpattu",
    "Chennai",
    "Coimbatore",
    "Cuddalore",
    "Dharmapuri",
    "Dindigul",
    "Erode",
    "Kallakurichi",
    "Kancheepuram",
    "Kanniyakumari",
    "Karur",
    "Krishnagiri",
    "Madurai",
    "Mayiladuthurai",
    "Nagapattinam",
    "Namakkal",
    "Perambalur",
    "Pudukkottai",
    "Ramanathapuram",
    "Ranipet",
    "Salem",
    "Sivaganga",
    "Tenkasi",
    "Thanjavur",
    "Theni",
    "Thoothukudi",
    "Tiruchirappalli",
    "Tirunelveli",
    "Tirupathur",
    "Tiruppur",
    "Tiruvallur",
    "Tiruvannamalai",
    "Tiruvarur",
    "Vellore",
    "Viluppuram",
    "Virudhunagar",
];

const news = [
    {
        date: "12 Oct",
        tag: "Announcement",
        title: "Department announcements and farmer updates",
    },
    {
        date: "08 Oct",
        tag: "Schemes",
        title: "Information on horticulture assistance schemes",
    },
    {
        date: "02 Oct",
        tag: "Training",
        title: "Modern farming training programme information",
    },
];

const events = [
    { day: "18", month: "OCT", name: "Farmer Awareness Programme" },
    { day: "24", month: "OCT", name: "Modern Horticulture Workshop" },
    { day: "30", month: "OCT", name: "Sustainable Farming Seminar" },
];

function SectionTitle({ title, subtitle, link, href = "#services" }) {
    return (
        <div className="d-flex justify-content-between align-items-start gap-3 mb-4">
            <div>
                <h2 className="h4 fw-bold mb-1" style={{ color: DARK }}>
                    {title}
                </h2>
                {subtitle && <p className="text-secondary small mb-0">{subtitle}</p>}
            </div>
            {link && (
                <a
                    href={href}
                    className="small fw-semibold text-decoration-none flex-shrink-0"
                    style={{ color: GREEN }}
                >
                    {link} →
                </a>
            )}
        </div>
    );
}

function Header({ search, setSearch, highContrast, setHighContrast }) {
    const [language, setLanguage] = useState("English");
    const [selectedTheme, setSelectedTheme] = useState("theme4");

    const navigate = useNavigate();
   
    const handleThemeChange = (value) => {
        setSelectedTheme(value);

        if (value === "theme4") {
            navigate("/model2");
        } else if (value === "theme5") {
            navigate("/model3");
        } else {
            navigate("/");
        }
    };

    return (
        <>
            <div className="text-white py-2" style={{ backgroundColor: DARK }}>
                <div className="container d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <span className="small">
                        🇮🇳 Government of Tamil Nadu
                    </span>

                    <div className="d-flex align-items-center gap-3">
                        <a
                            href="#main-content"
                            className="small text-white text-decoration-none"
                        >
                            Skip to content
                        </a>

                        <button
                            type="button"
                            className="btn btn-sm btn-outline-light py-0"
                            onClick={() => setHighContrast(!highContrast)}
                            aria-pressed={highContrast}
                        >
                            {highContrast ? "Normal Contrast" : "High Contrast"}
                        </button>

                        <select
                            className="form-select form-select-sm"
                            aria-label="Select language"
                            style={{ width: 120 }}
                            value={language}
                            onChange={(event) => setLanguage(event.target.value)}
                        >
                            <option>English</option>
                            <option>Tamil</option>
                        </select>
                        <select
                            className="form-select form-select-sm"
                            aria-label="Select theme"
                            style={{ width: 120 }}
                            value={selectedTheme}
                            onChange={(e) => handleThemeChange(e.target.value)}
                        >
                            <option value="theme1">Theme 1</option>
                            <option value="theme2">Theme 2</option>
                            <option value="theme3">Theme 3</option>
                            <option value="theme4">Theme 4</option>
                            <option value="theme5">Theme 5</option>
                        </select>
                    </div>
                </div>
            </div>

            <header className="bg-white border-bottom">
                <div className="container py-3">
                    <div className="row align-items-center g-3">
                        <div className="col-12 col-lg-4">
                            <a
                                href="#home"
                                className="d-flex align-items-center gap-3 text-decoration-none"
                            >
                                <div
                                    className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                    style={{
                                        width: 56,
                                        height: 56,
                                        backgroundColor: "#e8f4e6",
                                        fontSize: 28,
                                    }}
                                >
                                    🌿
                                </div>
                                <div>
                                    <div className="fw-bold text-dark">
                                        Department of Horticulture
                                    </div>
                                    <div className="fw-semibold text-dark">
                                        and Plantation Crops
                                    </div>
                                    <small className="text-secondary">
                                        Government of Tamil Nadu
                                    </small>
                                </div>
                            </a>
                        </div>

                        <div className="col-12 col-lg-8">
                            <form
                                className="input-group"
                                role="search"
                                onSubmit={(event) => {
                                    event.preventDefault();
                                    document
                                        .getElementById("services")
                                        ?.scrollIntoView({ behavior: "smooth" });
                                }}
                            >
                                <label htmlFor="site-search" className="visually-hidden">
                                    Search department services and schemes
                                </label>
                                <input
                                    id="site-search"
                                    type="search"
                                    className="form-control form-control-lg"
                                    placeholder="What are you looking for? Try subsidy, crops..."
                                    value={search}
                                    onChange={(event) => setSearch(event.target.value)}
                                />
                                <button
                                    type="submit"
                                    className="btn text-white px-4"
                                    style={{ backgroundColor: GREEN }}
                                >
                                    🔎 Search
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </header>

            <nav
                className="navbar navbar-expand-lg navbar-dark sticky-top shadow-sm"
                style={{ backgroundColor: GREEN }}
                aria-label="Main navigation"
            >
                <div className="container">
                    <a className="navbar-brand fw-bold d-lg-none" href="#home">
                        Horticulture
                    </a>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#departmentNavbar"
                        aria-controls="departmentNavbar"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon" />
                    </button>

                    <div className="collapse navbar-collapse" id="departmentNavbar">
                        <ul className="navbar-nav w-100 justify-content-between">
                            {[
                                ["Home", "#home"],
                                ["About Department", "#about"],
                                ["Schemes", "#schemes"],
                                ["Farmer Services", "#services"],
                                ["Crop Information", "#crops"],
                                ["News & Events", "#updates"],
                                ["Contact", "#footer"],
                            ].map(([label, href], index) => (
                                <li className="nav-item" key={label}>
                                    <a
                                        className={`nav-link px-lg-3 ${index === 0 ? "active fw-bold" : ""
                                            }`}
                                        aria-current={index === 0 ? "page" : undefined}
                                        href={href}
                                    >
                                        {label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}

function Hero({ onAction }) {
    return (
        <section
            id="home"
            className="text-white"
            style={{
                backgroundColor: DARK,
                backgroundImage:
                    "linear-gradient(90deg, rgba(4,57,35,.96), rgba(4,57,35,.82), rgba(4,57,35,.25)), url('https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1800&q=85')",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <div className="container py-5">
                <div className="row align-items-center g-4">
                    <div className="col-lg-8 py-3">
                        <span className="badge rounded-pill bg-success-subtle text-success-emphasis mb-3 px-3 py-2">
                            GROWING A GREENER TAMIL NADU
                        </span>

                        <h1 className="display-4 fw-bold mb-3">
                            Growing Horticulture.
                            <br />
                            <span style={{ color: "#d7f39a" }}>
                                Empowering Farmers.
                            </span>
                        </h1>

                        <p className="lead mb-4">
                            Better crops. Healthier lives. A greener tomorrow.
                            <br className="d-none d-md-block" />
                            Discover support, schemes and knowledge for every farmer.
                        </p>

                        <div className="d-flex flex-wrap gap-3">
                            <a href="#services" className="btn btn-lg btn-success px-4">
                                Explore Services →
                            </a>
                            <a
                                href="#schemes"
                                className="btn btn-lg btn-outline-light px-4"
                            >
                                View Schemes
                            </a>
                        </div>

                        <div className="mt-4 small">
                            ✓ Farmer services &nbsp; ✓ Crop guidance &nbsp; ✓ District
                            information
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                            <div className="card-body p-4">
                                <h2 className="h5 fw-bold text-dark mb-3">
                                    Quick Access
                                </h2>

                                {[
                                    ["📄", "Apply Online"],
                                    ["🔎", "Track Application"],
                                    ["👨‍🌾", "Find an Officer"],
                                    ["📞", "Contact Department"],
                                ].map(([icon, label]) => (
                                    <button
                                        type="button"
                                        key={label}
                                        onClick={() => onAction(label)}
                                        className="btn btn-light border-0 w-100 text-start py-3 mb-2 d-flex align-items-center gap-3"
                                    >
                                        <span className="fs-4">{icon}</span>
                                        <span className="fw-semibold text-dark">{label}</span>
                                        <span className="ms-auto text-success">→</span>
                                    </button>
                                ))}

                                <small className="text-secondary">
                                    Quick links to frequently used services.
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function QuickServices({ search, onAction }) {
    const filteredServices = services.filter((service) =>
        `${service.title} ${service.desc}`
            .toLowerCase()
            .includes(search.toLowerCase().trim())
    );

    return (
        <section id="services" className="py-5">
            <SectionTitle
                title="How can we help you?"
                subtitle="Choose a task to get started. No need to browse multiple pages."
            />

            <div className="row g-3">
                {filteredServices.map((service, index) => (
                    <div className="col-6 col-md-4 col-lg-2" key={service.title}>
                        <button
                            type="button"
                            onClick={() => onAction(service.title)}
                            className="card border h-100 w-100 text-start shadow-sm p-3"
                            style={{
                                borderRadius: 16,
                                transition: "box-shadow .2s ease",
                            }}
                        >
                            <div
                                className="rounded-3 d-flex align-items-center justify-content-center mb-3"
                                style={{
                                    width: 52,
                                    height: 52,
                                    fontSize: 25,
                                    backgroundColor: [
                                        "#e5f4df",
                                        "#e5efff",
                                        "#dff7f5",
                                        "#fff0df",
                                        "#eee5ff",
                                        "#ffe4eb",
                                    ][index],
                                }}
                            >
                                {service.icon}
                            </div>

                            <h3 className="h6 fw-bold text-dark">
                                {service.title}
                            </h3>
                            <p className="small text-secondary flex-grow-1 mb-3">
                                {service.desc}
                            </p>

                            <span className="small fw-bold" style={{ color: GREEN }}>
                                Get started →
                            </span>
                        </button>
                    </div>
                ))}

                {filteredServices.length === 0 && (
                    <div className="col-12">
                        <div className="alert alert-warning">
                            No matching services found. Try searching for subsidy, farmer,
                            irrigation or officer.
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}

function Statistics() {
    const stats = [
        ["🌱", "Area Covered", "XX", "Hectares"],
        ["👨‍🌾", "Farmers Benefited", "XX", "Farmers"],
        ["📍", "Districts Covered", "XX", "Districts"],
        ["📋", "Schemes Implemented", "XX", "Schemes"],
        ["🪴", "Nurseries", "XX", "Nurseries"],
    ];

    return (
        <section
            className="py-4"
            style={{ backgroundColor: "#eff7eb" }}
            aria-label="Horticulture statistics"
        >
            <div className="container">
                <SectionTitle
                    title="Horticulture at a Glance"
                    subtitle="Key department statistics"
                />

                <div className="row g-3">
                    {stats.map(([icon, label, value, unit]) => (
                        <div className="col-6 col-md" key={label}>
                            <div className="card border-0 rounded-4 h-100 text-center p-3">
                                <div className="fs-2 mb-2">{icon}</div>
                                <div className="small text-secondary">{label}</div>
                                <div className="h3 fw-bold my-2" style={{ color: GREEN }}>
                                    {value}
                                </div>
                                <small className="text-secondary">{unit}</small>
                            </div>
                        </div>
                    ))}
                </div>

                <p className="small text-secondary mt-3 mb-0">
                    Note: Replace XX with verified, current department statistics.
                </p>
            </div>
        </section>
    );
}

function Schemes() {
    return (
        <section className="py-5" id="schemes">
            <SectionTitle
                title="Schemes & Guidelines"
                subtitle="Explore programmes that support sustainable horticulture."
                link="All schemes"
                href="#downloads"
            />

            <div className="row g-4">
                {schemes.map((scheme) => (
                    <div className="col-6 col-md-4 col-lg-2" key={scheme.title}>
                        <article className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden">
                            <img
                                src={scheme.image}
                                alt={scheme.title}
                                className="card-img-top"
                                loading="lazy"
                                style={{ height: 125, objectFit: "cover" }}
                            />

                            <div className="card-body p-3">
                                <h3 className="h6 fw-bold">{scheme.title}</h3>
                                <p className="small text-secondary">{scheme.desc}</p>
                                <a
                                    href="#downloads"
                                    className="small fw-semibold text-decoration-none"
                                    style={{ color: GREEN }}
                                >
                                    View details →
                                </a>
                            </div>
                        </article>
                    </div>
                ))}
            </div>
        </section>
    );
}

function CropExplorer({ onAction }) {
    return (
        <section className="pb-5" id="crops">
            <SectionTitle
                title="Explore by Crop"
                subtitle="Find cultivation information, best practices and support schemes."
            />

            <div className="row g-3">
                {crops.map((crop) => (
                    <div className="col-6 col-lg-3" key={crop.name}>
                        <button
                            type="button"
                            className="card border-0 rounded-4 shadow-sm overflow-hidden w-100 text-white text-start"
                            onClick={() => onAction(`${crop.name} Crop Information`)}
                        >
                            <img
                                src={crop.image}
                                alt=""
                                loading="lazy"
                                style={{ height: 155, objectFit: "cover" }}
                            />

                            <div
                                className="card-body d-flex align-items-center justify-content-between"
                                style={{ backgroundColor: GREEN }}
                            >
                                <span className="fw-bold">
                                    {crop.icon} {crop.name}
                                </span>
                                <span className="rounded-circle bg-white text-success px-2 py-1">
                                    →
                                </span>
                            </div>
                        </button>
                    </div>
                ))}
            </div>
        </section>
    );
}

function DistrictFinder({ onAction }) {
    const [district, setDistrict] = useState("");
    const [category, setCategory] = useState("All Services");

    return (
        <section id="about" className="py-5">
            <div
                className="card border-0 rounded-4 overflow-hidden"
                style={{ backgroundColor: "#edf6e8" }}
            >
                <div className="card-body p-4 p-lg-5">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <span className="badge bg-success-subtle text-success-emphasis mb-3">
                                DISTRICT SERVICES
                            </span>

                            <h2 className="display-6 fw-bold" style={{ color: DARK }}>
                                Find support near you.
                            </h2>

                            <p className="text-secondary">
                                Discover local horticulture services, department contacts,
                                schemes and resources for your district.
                            </p>

                            <div className="d-flex flex-wrap gap-2 mt-4">
                                <span className="badge rounded-pill bg-white text-success p-2">
                                    📍 District offices
                                </span>
                                <span className="badge rounded-pill bg-white text-success p-2">
                                    🌱 Plant nurseries
                                </span>
                                <span className="badge rounded-pill bg-white text-success p-2">
                                    📋 Local schemes
                                </span>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="card border-0 rounded-4 shadow-sm">
                                <div className="card-body p-4">
                                    <h3 className="h5 fw-bold mb-3">
                                        District Information Finder
                                    </h3>

                                    <form
                                        onSubmit={(event) => {
                                            event.preventDefault();
                                            if (district) {
                                                onAction(
                                                    `${category} in ${district}`
                                                );
                                            }
                                        }}
                                    >
                                        <label htmlFor="district-select" className="form-label">
                                            Select your district
                                        </label>

                                        <select
                                            id="district-select"
                                            className="form-select form-select-lg mb-3"
                                            value={district}
                                            onChange={(event) => setDistrict(event.target.value)}
                                            required
                                        >
                                            <option value="">Choose district</option>
                                            {districts.map((item) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </select>

                                        <label htmlFor="district-category" className="form-label">
                                            What information do you need?
                                        </label>

                                        <select
                                            id="district-category"
                                            className="form-select form-select-lg mb-4"
                                            value={category}
                                            onChange={(event) => setCategory(event.target.value)}
                                        >
                                            <option>All Services</option>
                                            <option>Government Schemes</option>
                                            <option>Horticulture Officers</option>
                                            <option>Plant Nurseries</option>
                                            <option>Training Centres</option>
                                            <option>Crop Information</option>
                                        </select>

                                        <button
                                            type="submit"
                                            className="btn btn-success btn-lg w-100"
                                            disabled={!district}
                                        >
                                            Find Information →
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function LatestUpdates() {
    return (
        <section className="py-5" id="updates">
            <div className="row g-4">
                <div className="col-12 col-lg-4">
                    <div className="card h-100 rounded-4 shadow-sm">
                        <div className="card-body p-4">
                            <SectionTitle
                                title="Latest Updates"
                                subtitle="News and notifications"
                                link="View all"
                                href="#downloads"
                            />

                            {news.map((item) => (
                                <article
                                    key={item.title}
                                    className="border-bottom py-3"
                                >
                                    <div className="d-flex gap-3">
                                        <span className="small text-secondary flex-shrink-0">
                                            {item.date}
                                        </span>
                                        <div>
                                            <span className="badge bg-success-subtle text-success-emphasis mb-2">
                                                {item.tag}
                                            </span>
                                            <p className="small fw-semibold mb-0">{item.title}</p>
                                        </div>
                                    </div>
                                </article>
                            ))}

                            <p className="small text-secondary mt-3 mb-0">
                                Replace sample announcements with verified official updates.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-4">
                    <div className="card h-100 rounded-4 shadow-sm">
                        <div className="card-body p-4">
                            <SectionTitle
                                title="Upcoming Events"
                                subtitle="Programmes and training"
                                link="View all"
                                href="#downloads"
                            />

                            {events.map((event) => (
                                <div
                                    className="d-flex gap-3 align-items-center border-bottom py-3"
                                    key={event.name}
                                >
                                    <div
                                        className="text-center rounded-3 p-2 flex-shrink-0"
                                        style={{
                                            backgroundColor: "#e8f4e6",
                                            color: GREEN,
                                            minWidth: 60,
                                        }}
                                    >
                                        <div className="h4 fw-bold mb-0">{event.day}</div>
                                        <small>{event.month}</small>
                                    </div>
                                    <div className="fw-semibold small">{event.name}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-4" id="downloads">
                    <div className="card h-100 rounded-4 shadow-sm">
                        <div className="card-body p-4">
                            <SectionTitle
                                title="Downloads"
                                subtitle="Forms and useful guidelines"
                            />

                            {[
                                "Scheme Application Forms",
                                "Horticulture Guidelines",
                                "Farmer Information Booklet",
                                "Training Materials",
                                "Government Orders",
                            ].map((item) => (
                                <a
                                    href="#footer"
                                    key={item}
                                    className="d-flex justify-content-between align-items-center gap-2 py-3 border-bottom text-decoration-none"
                                >
                                    <span className="small text-dark">📄 {item}</span>
                                    <span className="text-success">↓</span>
                                </a>
                            ))}

                            <p className="small text-secondary mt-3">
                                Link each document to its approved official file.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function Footer() {
    return (
        <footer
            id="footer"
            className="text-white"
            style={{ backgroundColor: DARK }}
        >
            <div className="container py-5">
                <div className="row g-4">
                    <div className="col-12 col-md-6 col-lg-4">
                        <h2 className="h5 fw-bold">🌿 Horticulture Department</h2>
                        <p className="small text-white-50">
                            Department of Horticulture and Plantation Crops
                            <br />
                            Government of Tamil Nadu
                        </p>
                        <p className="small">
                            Supporting farmers and promoting sustainable horticulture.
                        </p>
                    </div>

                    <div className="col-6 col-md-3 col-lg-2">
                        <h3 className="h6 fw-bold">Department</h3>
                        {[
                            ["About Us", "#about"],
                            ["Schemes", "#schemes"],
                            ["Farmer Services", "#services"],
                            ["Crop Information", "#crops"],
                        ].map(([label, href]) => (
                            <a
                                key={label}
                                href={href}
                                className="d-block text-white-50 small text-decoration-none mb-3"
                            >
                                {label}
                            </a>
                        ))}
                    </div>

                    <div className="col-6 col-md-3 col-lg-2">
                        <h3 className="h6 fw-bold">Quick Links</h3>
                        {[
                            ["News & Events", "#updates"],
                            ["Downloads", "#downloads"],
                            ["District Finder", "#about"],
                            ["Contact", "#footer"],
                        ].map(([label, href]) => (
                            <a
                                key={label}
                                href={href}
                                className="d-block text-white-50 small text-decoration-none mb-3"
                            >
                                {label}
                            </a>
                        ))}
                    </div>

                    <div className="col-12 col-md-6 col-lg-4">
                        <h3 className="h6 fw-bold">Need Assistance?</h3>
                        <p className="small text-white-50">
                            Use the official department contact details to get support
                            regarding schemes, applications and crop services.
                        </p>
                        <a
                            href="#services"
                            className="btn btn-outline-light"
                        >
                            Find a Service →
                        </a>
                    </div>
                </div>

                <hr className="border-light opacity-25 my-4" />

                <div className="d-flex flex-wrap justify-content-between gap-3">
                    <small className="text-white-50">
                        © {new Date().getFullYear()} Department of Horticulture,
                        Government of Tamil Nadu.
                    </small>
                    <a
                        href="#home"
                        className="text-white text-decoration-none small"
                    >
                        Back to top ↑
                    </a>
                </div>
            </div>
        </footer>
    );
}

function ActionDialog({ action, onClose }) {
    if (!action) return null;

    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-3"
            style={{
                zIndex: 2000,
                backgroundColor: "rgba(0,0,0,.55)",
            }}
            role="presentation"
            onClick={onClose}
        >
            <div
                className="card border-0 rounded-4 shadow-lg"
                style={{ width: "100%", maxWidth: 480 }}
                role="dialog"
                aria-modal="true"
                aria-labelledby="action-dialog-title"
                onClick={(event) => event.stopPropagation()}
            >
                <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-start gap-3">
                        <h2
                            id="action-dialog-title"
                            className="h4 fw-bold"
                            style={{ color: DARK }}
                        >
                            {action}
                        </h2>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close dialog"
                            onClick={onClose}
                        />
                    </div>

                    <p className="text-secondary mt-3">
                        This service needs to be connected to the relevant official
                        department portal or API before it can process requests.
                    </p>

                    <div className="alert alert-info small">
                        No application has been submitted. This is a frontend
                        demonstration.
                    </div>

                    <button
                        type="button"
                        className="btn btn-success w-100"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}

export default function Model2() {
    const [search, setSearch] = useState("");
    const [activeAction, setActiveAction] = useState("");
    const [highContrast, setHighContrast] = useState(false);

    return (
        <div
            className="min-vh-100"
            style={{
                backgroundColor: highContrast ? "#fff" : "#fbfcfa",
                color: highContrast ? "#000" : "#24352a",
                filter: highContrast ? "contrast(1.12)" : "none",
            }}
        >
            <Header
                search={search}
                setSearch={setSearch}
                highContrast={highContrast}
                setHighContrast={setHighContrast}
            />

            <main id="main-content">
                <Hero onAction={setActiveAction} />

                <div className="container">
                    <QuickServices search={search} onAction={setActiveAction} />
                </div>

                <Statistics />

                <div className="container">
                    <Schemes />
                    <CropExplorer onAction={setActiveAction} />
                    <DistrictFinder onAction={setActiveAction} />
                    <LatestUpdates />
                </div>
            </main>

            <Footer />

            <ActionDialog
                action={activeAction}
                onClose={() => setActiveAction("")}
            />
        </div>
    );
}